import { render, staticRenderFns } from "./PageShopSkeleton.vue?vue&type=template&id=9d1cff04"
import script from "./PageShopSkeleton.vue?vue&type=script&lang=js"
export * from "./PageShopSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageShopSkeleton.vue?vue&type=style&index=0&id=9d1cff04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports